import { Popover as BasePopover } from "@base-ui/react/popover";

import type { YearPickerBackdropProps } from "./YearPicker.types";

export function YearPickerBackdrop({ ...props }: YearPickerBackdropProps) {
  return <BasePopover.Backdrop data-slot="year-picker-backdrop" {...props} />;
}
